import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { DetailsPageRoutingModule } from './details-routing.module';
import { DetailsPageComponent } from './details.page';

@NgModule({
  declarations: [DetailsPageComponent],
  imports: [FormsModule, IonicModule, DetailsPageRoutingModule, MiscModule, CommonModule]
})
export class DetailsPageModule {}
